import { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './sidebar';
import Header from './topbar';
import { LayoutProvider } from '../../contexts/LayoutContext';
import ChildLayout from './child';

import { bridgeDaysService } from '../../api/bridge-days';
import { examinationsService } from '../../api/examinations';
import { intermediaryService } from '../../api/intermediary';
import { measurementService } from '../../api/measurement';
import { userService } from '../../api/user';
import { dropdownService } from '../../api/dropdown';

import { setAllBridgeDays } from '../../store/reducers/bridge-days';
import { setAllExaminations } from '../../store/reducers/examinations';
import { setAllIntermediaries } from '../../store/reducers/intermediary';
import { setAllMeasurements } from '../../store/reducers/measurement';
import { setAllUsers } from '../../store/reducers/adminuser';
import { allMeasurements, setAllAccordingToParagraph } from '../../store/reducers/dropdown';
import { useDispatch } from 'react-redux';
import { useAuth } from '../../contexts/AuthContext';
import NormalChildLayout from './child/normal';
import { lecturersService } from '../../api/lecturers';
import { setAllLecturers } from '../../store/reducers/lecturers';
import { studentsService } from '../../api/students';
import { setAllStudents } from '../../store/reducers/students';
import { carrierFeedbackService } from '../../api/carrier-feedback';
import { setOrganizationTree } from '../../store/reducers/carrier-feedback';
import ScrollToTop from '../ScrollToTop';

const Layout = memo(({ normal = false }) => {
    const { logout } = useAuth()
    const dispatch = useDispatch()
    const lastCalledRef = useRef(0);

    useEffect(() => {
        if (global?.auth_token) {
            const now = new Date().getTime();
            if (now - lastCalledRef.current > 5000) {
                lastCalledRef.current = now;
                (async () => {
                    try {
                        // Dropdown
                        const response_accordingToParagraph = await dropdownService.getAllAccordingToParagraph();
                        if (response_accordingToParagraph) { dispatch(setAllAccordingToParagraph(response_accordingToParagraph?.data)) }
                        // Bridge Days
                        const response_bridgeDays = await bridgeDaysService.getAllBridgeDays();
                        if (response_bridgeDays) { dispatch(setAllBridgeDays(response_bridgeDays?.data)) }
                        // Examinations
                        const response_examinations = await examinationsService.getAllExaminations();
                        if (response_examinations) { dispatch(setAllExaminations(response_examinations?.data)) }
                        // Intermediaries
                        const response_intermediaries = await intermediaryService.getAllIntermediaries();
                        if (response_intermediaries) { dispatch(setAllIntermediaries(response_intermediaries?.data)) }
                        // Measurements
                        const response_measurements = await measurementService.getAllMeasurements();
                        if (response_measurements) {
                            dispatch(setAllMeasurements(response_measurements?.data))
                            dispatch(allMeasurements(response_measurements?.data?.filter(i => i?.show_in_documents == 1)?.map((item, index) => ({ ...item, title: item?.measures_title, measures_title: `${item?.measures_number} - ${item?.measures_title}` }))))
                        }
                        // Users
                        const response_users = await userService.getAllUsers();
                        if (response_users) { dispatch(setAllUsers(response_users)) }
                        // Lecturers
                        const response_lecturers = await lecturersService.getAllLecturers();
                        if (response_lecturers) { dispatch(setAllLecturers(response_lecturers?.data)) }

                        // Students
                        const response_students = await studentsService.getAllStudents();
                        if (response_students?.success) { dispatch(setAllStudents(response_students?.data)) }

                        // Organization Tree
                        const response_organizationTree = await carrierFeedbackService.organizationTree();
                        if (response_organizationTree?.success) { dispatch(setOrganizationTree(response_organizationTree?.data)) }
                    } catch (error) {
                        if (error?.response?.status === 401) { logout?.() }
                    }
                })();
            }
        }
    }, [global.auth_token]);

    return (
        <ScrollToTop>
            <LayoutProvider>
                {!normal && (
                    <>
                        <Header key="header" />
                        <Sidebar key="sidebar" type="admin" />
                        <ChildLayout key="child" />
                    </>
                )}
                {normal && (<NormalChildLayout key="child" />)}
            </LayoutProvider>
        </ScrollToTop>
    );
});

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;